import * as FaIcons from "react-icons/fa";
import * as SiIcons from "react-icons/si";
const SkillsData = [
  {
    name: "ReactJs",
    icon: <FaIcons.FaReact className="pl-1" color="#61dafb" />,
    iconType: "Fa",
    color: "#61dafb",
  },
  {
    name: "NextJs",
    icon: <SiIcons.SiNextdotjs className="pl-1" color="#000000" />,
    iconType: "Si",
    color: "#000000",
  },
  {
    name: "JavaScript",
    icon: <SiIcons.SiJavascript className="pl-1" color="#fcdc00" />,
    iconType: "Si",
    color: "#fcdc00",
  },
  {
    name: "TypeScript",
    icon: <SiIcons.SiTypescript className="pl-1" color="#3178c6" />,
    iconType: "Si",
    color: "#3178c6",
  },
  {
    name: "VueJs",
    icon: <FaIcons.FaVuejs className="pl-1" color="#41b883" />,
    iconType: "Fa",
    color: "#41b883",
  },
  {
    name: "NuxtJs",
    icon: <SiIcons.SiNuxtdotjs className="pl-1" color="#41b883" />,
    iconType: "Fa",
    color: "#000000",
  },
  {
    name: "NodeJs",
    icon: <FaIcons.FaNodeJs className="pl-1" color="#026e00" />,
    iconType: "Fa",
    color: "#026e00",
  },
  {
    name: "ExpressJs",
    icon: <SiIcons.SiExpress className="pl-1" color="#000000" />,
    iconType: "Si",
    color: "#000000",
  },
  {
    name: "MongoDB",
    icon: <SiIcons.SiMongodb className="pl-1" color="#4db33d" />,
    iconType: "Si",
    color: "#4db33d",
  },
  {
    name: "TailwindCSS",
    icon: <SiIcons.SiTailwindcss className="pl-1" color="#3b82f680" />,
    iconType: "Si",
    color: "#3b82f680",
  },
  {
    name: "NestJs",
    icon: <SiIcons.SiNestjs className="pl-1" color="#026e00" />,
    iconType: "Si",
    color: "#026e00",
  },
  {
    name: "Firebase",
    icon: <SiIcons.SiFirebase className="pl-1" color="#f7c52b" />,
    iconType: "Si",
    color: "#f7c52b",
  },
  {
    name: "Git",
    icon: <SiIcons.SiGit className="pl-1" color="#f34f29" />,
    iconType: "Si",
    color: "#f34f29",
  },
  {
    name: "GitHub",
    icon: <SiIcons.SiGithub className="pl-1" color="#000000" />,
    iconType: "Si",
    color: "#000000",
  },

  {
    name: "HTML5",
    icon: <SiIcons.SiHtml5 className="pl-1" color="#e34f26" />,
    iconType: "Si",
    color: "#e34f26",
  },
  {
    name: "CSS3",
    icon: <SiIcons.SiCss3 className="pl-1" color="#2965f1" />,
    iconType: "Si",
    color: "#2965f1",
  },
  {
    name: "Sass",
    icon: <SiIcons.SiSass className="pl-1" color="#c69" />,
    iconType: "Si",
    color: "#c69",
  },
];

const Fields = [
  "Frontend Developement",
  "Web Developement",
  "Backend Developement",
  "UI/UX Designer",
  "Full Stack Developement",
  "Mobile App Developement",
  "Content Creator",
];

export default {
  SkillsData,
  Fields,
};
